'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/stickyAtb'));
    processInclude(require('./product/sizeChart'));
    processInclude(require('richemont/product/boutiques'));
    processInclude(require('richemont/product/deliveryDate'));
});
